<ng-container *ngIf="!isCancelled || hasPassengersOrAddOns(taskDetails)">
<div class="assign">
    <div class="assigned-driver-row" [class.centered]="isRemoteParkingTask">
        <div *ngIf="!isRemoteParkingTask; else remoteParkingLabel" class="coordDriverStatusColorCircle"
            [ngClass]="taskDetails?.taskTypeName !== 'Other' ? getStatusColor(taskDetails?.status || DispatchTaskStatus.UNASSIGNED) : ''">
        </div>
        <ng-template #remoteParkingLabel>
            <div class="remote-parking-label">Assigned to:</div>
        </ng-template>
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select placeholder="Select" #rowType
                (selectionChange)="assignDriverFromDropdown($event.value, taskDetails)"
                [value]="isCancelled ? 'Cancelled' : (taskDetails?.assignedTo?.toLowerCase() || '')">
                <mat-option [value]="''">Unassigned</mat-option>
                <mat-option *ngIf="isCancelled" value="Cancelled">Cancelled</mat-option>
                <mat-option *ngFor="let driver of driverList" [value]="driver?.driverId?.toLowerCase() || ''">{{
                    getDriverSummaryDisplayName(driver) }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <form *ngIf="!isRemoteParkingTask && taskDetails?.assignedTo" class="pickup-dropoff-form">
            <div>
                <label>Pickup</label>
                <input [formControl]="pickupTimeCtrl" #thisVal (blur)="updateTaskTime(taskDetails, 'pickupTime')" appTimeInputMask placeholder="HH:MM" maxlength="5">
                <span class="spinnerGif-dispatchFilter" [class.hidden]="!loadPickup"></span>
            </div>
            <div>
                <label>Dropoff</label>
                <input [formControl]="dropOffTimeCtrl" (blur)="updateTaskTime(taskDetails, 'dropoffTime')" appTimeInputMask placeholder="HH:MM" maxlength="5">
                <span class="spinnerGif-dispatchFilter" [class.hidden]="!loadDropoff"></span>
            </div>
        </form>

    </div>

    <ng-container [ngSwitch]="taskDetails?.taskTypeName || ''">

        <ng-container *ngSwitchCase="TaskType.RemoteParking"></ng-container>

        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="((taskDetails?.taskTypeName || '') !== TaskType.Other) ? dropZone : nonDropZone; context: { $implicit: taskDetails }"></ng-container>

            <form [formGroup]="dispatchDropzoneForm">
                <div class="added-type-section" formArrayName="addPassengersAndAddOnsFormArray">
                    <div *ngFor="let addType of addPassengersAndAddOnsFormArray.controls;let i=index"
                        class="section-row">
                        <div [formGroupName]="i" class="selection-form-group">
                            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <mat-select placeholder="Type" #rowType formControlName="type">
                                    <mat-option *ngFor="let type of typeDetailTypes" [value]="type">{{type}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <div class="input-add">
                                <input matInput #addTypeName formControlName="name" />
                                <button mat-raised-button
                                    (click)="addPassengerOrAddOn(i, taskDetails.metadata?.flightId)">Add
                                    +</button>
                            </div>
                            <button mat-icon-button class="remove-details" variant="outlined"
                                (click)="removeNewPassengerOrAddOnFormItem(i)">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </form>
            <button *ngIf="taskDetails" mat-icon-button aria-label="Add Pickup Details" class="add-pickup-button"
                (click)="pushNewPassengerOrAddOnToForm($event)">
                <mat-icon>add_circle</mat-icon>
            </button>
        </ng-container>
    </ng-container>
</div>
</ng-container>

<ng-template #dropZone let-taskDetails>
    <div cdkDropList [cdkDropListData]="taskDetails" class="drop-to-unassign"
        [class.empty-dropzone]="!hasPassengersOrAddOns(taskDetails)"
        (cdkDropListDropped)="onPassengerOrAddOnDrop($event)" [cdkDropListDisabled]="dropListDisabled">

        <span *ngIf="!hasPassengersOrAddOns(taskDetails) && !dropListDisabled">
            {{ taskDetails?.assignedTo ? 'Drop here to assign' : 'Drop here to unassign' }}
        </span>

        <div cdkDrag [cdkDragData]="wrapPassengerOrAddOn(passenger, 'passenger')" *ngFor="let passenger of passengers"
            class="driveable-item draggable" (cdkDragDropped)="removeFromPreviousContainer($event)">
            <ng-container *ngTemplateOutlet="passengerItem; context: { $implicit: passenger, taskDetails }">
            </ng-container>
        </div>

        <div cdkDrag [cdkDragData]="wrapPassengerOrAddOn(addOn, 'addon')" *ngFor="let addOn of addOns"
            class="driveable-item draggable" (cdkDragDropped)="removeFromPreviousContainer($event)">
            <ng-container *ngTemplateOutlet="addOnItem; context: { $implicit: addOn }"></ng-container>
        </div>

        <div *ngIf="dropListDisabled" class="driveable-item--loading">
            Please wait <span class="spinnerGif-dispatchFilter"></span>
        </div>

    </div>

</ng-template>

<ng-template #nonDropZone let-taskDetails>
    <div class="drop-to-unassign" [class.no-drop]="taskDetails.taskTypeName === TaskType.Other">
        <div *ngFor="let passenger of passengers" class="driveable-item draggable">
            <ng-container *ngTemplateOutlet="passengerItem; context: { $implicit: passenger, taskDetails }">
            </ng-container>
        </div>

        <div *ngFor="let addOn of addOns" class="driveable-item draggable">
            <ng-container *ngTemplateOutlet="addOnItem; context: { $implicit: addOn }"></ng-container>
        </div>
    </div>

</ng-template>

<ng-template #passengerItem let-passenger let-taskDetails="taskDetails">
    <div *ngIf="!isAdHocTask" class="icon-arrows"></div>
    <mat-icon class="icon-user-small" svgIcon="icon-user" aria-hidden="true"></mat-icon>
    <fa-icon class="icon-alert-dropzone alertDarkMode" *ngIf="!passenger.checkedIn" [icon]="warningIcon"
        style="color: orange;"></fa-icon>
    <span>{{ passenger.role }} {{ passenger.firstName }} {{ passenger.lastName }}</span>
    <button *ngIf="!isCancelled" mat-icon-button type="button" class="close-icon-button"
        (click)="$event.stopPropagation(); deletePassengerOrAddOnItem(passenger, taskDetails, 'passenger')"
        (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
        [disabled]="disableDeleteItemButtons">
        <mat-icon class="icon-close-red"></mat-icon>
    </button>
</ng-template>

<ng-template #addOnItem let-addOn>
    <div *ngIf="!isAdHocTask" class="icon-arrows"></div>
    <ng-container [ngSwitch]="addOn.type">
        <div *ngSwitchCase="'Other'" class="icon-tasks-small"></div>
        <div *ngSwitchCase="'Passenger'" class="icon-user-small"></div>
        <div *ngSwitchCase="'Paperwork'" class="icon-file"></div>
        <div *ngSwitchCase="'Catering'" class="icon-cutlery"></div>
    </ng-container>
    <span>{{ addOn.name }}</span>
    <button *ngIf="!isCancelled" mat-icon-button type="button" class="close-icon-button"
        (click)="$event.stopPropagation(); deletePassengerOrAddOnItem(addOn, taskDetails, 'addon')"
        (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()"
        [disabled]="disableDeleteItemButtons">
        <mat-icon class="icon-close-red"></mat-icon>
    </button>
</ng-template>